module.exports = __webpack_public_path__ + "static/media/lock.041d7ef2.svg";